<template>
    <div class="counter-box">
       <div class="barContainer">
            <div class="bar" v-for="index in max" :key="index" :class="{active: actual >= (index)}"> 
            </div>   
        </div>
    </div>
</template>

<script>


export default {
    props: [
        'actual',
        'max'
    ]
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .counter-box{
        margin-top: 62.5px;
        margin-bottom: 12px;
        .barContainer {
            height: 11px;
            border-radius: 50px;
            height: 10px;
            margin: 0 auto;
            .bar{
                height: 9px;
                width: 35px;
                display: inline-block;
                margin: 0 auto;
                background-color: #eef2f3;
                border: solid 1px #ffffff;

                &.active {

                    background-color: #d31567;
                }
            }
        }


    }
</style>
